import './css/navbar.css';

import Logo from './images/logo.png';


function Navbar(props){
    return(
        <>
        
        <nav>
            

            <div className={`container-fluid ${props.className}`}>


            <div className={`upper-nav ${props.className}`}>
                    <div className="row">
                        <div className="upper-content">
                            <div className="login">
                                <a href="#">
                                    <i className="fa-solid fa-cart-shopping"></i>
                                </a>
                            </div>
    
                            <div className="search">
                                <form>
                                    <input type="text" placeholder=" عن ماذا تبحث ؟ " name="search"/>
                                </form>
                            </div>
    
                            <div className="logo">
                                <a href="index.html">
                                    <img src={Logo} alt="Ahla sakora logo" /> 
                                </a>
                            </div>
                        </div>
    
    
                    </div>
            </div>
    
    
            <div className="lower-nav">
                
                    <div className="row">
    
    
                        <div className="lower-content">
                            <div className="all-nav-elements">
                                <div className="category">
                                    <a href="#">  جميع الأقسام <i className="fa-solid fa-caret-down"></i></a>
                                    <ul>
    
                                        <li><a href="#">مكياج أحلى ساكورا </a>
                                        <ul className="sub-category">
                                            
                                            <h1>مكياج أحلى ساكورا </h1>
                                            <li><a href="#">  مكياج أحلى ساكورا  </a></li>
                                            <li><a href="#"> مكياج أحلى ساكورا </a></li>
                                            <li><a href="#">مكياج أحلى ساكورا </a></li>
                                            <li><a href="#">مكياج أحلى ساكورا </a></li>
                                            <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        </ul>
                                        </li>
                                        <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        <li><a href="#">مكياج أحلى ساكورا </a></li>
                                        
                                    </ul>
                                </div>
                            </div>
    
                            <div className="nav-elements">
    
                            <div className="nav-element">
    
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                </ul>
                            </div>
    
    
                            <div className="nav-element">
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                </ul>
                            </div>
    
    
                            <div className="nav-element">
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                </ul>
                            </div>
    
    
                            <div className="nav-element">
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                </ul>
                            </div>
    
    
                            <div className="nav-element">
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>

                                </ul>
                            </div>
    
    
                            <div className="nav-element">
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                </ul>
                            </div>
    
                            <div className="nav-element">
                                <a href="#">مكياج أحلى ساكورا </a>
                                <ul>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                    <li><a href="sub_category">مكياج أحلى ساكورا </a></li>
                                </ul>
                            </div>
    
                        </div>
    
    
    
                        </div>
                    </div>
            </div>

            </div>
    
    
        </nav> 
    
    
    
        </>
    )
}


export default Navbar;